<app-navbar>
    <h2>{{"ACCOUNT.ACCOUNT" | translate}}</h2>
</app-navbar>
<!--Title section will be replaced soon-->
<div class="container">
    <app-check-current-user></app-check-current-user>
</div>
<div class="container pb-60">
    <div class="row">
        <div class="col-md-3 accountSidebar">
            <a class="green-button" routerLink="/cont" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}">{{"ACCOUNT.ACCOUNT" | translate}}</a>
            <a class="green-button" routerLink="schimbare-parola" routerLinkActive="is-active">{{"ACCOUNT.PASSWORD_CHANGE" | translate}}</a>
            <a class="green-button" routerLink="editare" routerLinkActive="is-active">{{"ACCOUNT.EDIT" | translate}}</a>
            <div *ngIf="userRole === 'client'">
                <a class="green-button" *ngIf="!company" routerLink="/adauga-companie">{{"ACCOUNT.ADD_COMPANY" | translate}}</a>
                <a class="green-button" *ngIf="company" routerLink="/compania-mea/">{{"ACCOUNT.MY_COMPANY" | translate}}</a>
                <a class="green-button" *ngIf="company" routerLink="/adauga-job">{{"ACCOUNT.ADD_JOB" | translate}}</a>
                <a class="green-button" *ngIf="company" routerLink="/joburile-mele">{{"ACCOUNT.MY_JOBS" | translate}}</a>
                <a class="green-button" *ngIf="company" routerLink="/cont/credite">{{"ACCOUNT.CREDITE" | translate}}</a>
            </div>
            <div *ngIf="userRole === 'candidate'">
                <a class="green-button" routerLink="/profilul-meu">{{"ACCOUNT.MY_PROFILE" | translate}}</a>
                <a class="green-button" routerLink="/editeaza-profilul">{{"ACCOUNT.CREATE_CV" | translate}}</a>
                <a class="green-button" routerLink="/aplicatiile-mele">{{"ACCOUNT.MY_APPLICATIONS" | translate}}</a>
                <a class="green-button" routerLink="/joburi-favorite">{{"ACCOUNT.FAVORITE_JOBS" | translate}}</a>
            </div>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<app-footer></app-footer>
